import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestCancelService {
  sameComponent = false;
  private cancelPendingRequests$ = new Subject<void>();

  constructor() {}

  /** Cancels all pending Http requests. */
  cancelPendingRequests() {
    this.cancelPendingRequests$.next();
  }

  onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }
}
